import * as React from "react";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useTranslation } from "react-i18next";
import { ItemRow } from "pages/FoodAndBeverages/FBSettings/FoodAndBeveragesStyled";
import FoodImagePopup from "./FoodImagePopup";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { isUserBasic, isUserReadOnly } from "constant";
import { formatNumber } from '../../Util/Accounting';
import {
    API_CALLS
} from "redux/reduxToolkitServices/_commonApiCalls/api";
import { headersConfigData } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";

const AddGroup = ({
    handleOnDelete,
    handleOnAddButton,
    i,
    listType,
    DummyFoodImage,
    changeOrder,
    foodDetails,
    handleOnChangeTitle,
    handleOnChangePrice,
    parentIndex,
    img,
    list,
    setList,
    setIsSaveMenuDisabled
}) => {
    const { siteSettingsData, getUserRole } =
        useSelector((state) => state.commonReducers) || [];

    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [updatedImage, setUpdatedImage] = React.useState([]);
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const calculatedTitle =
        foodDetails?.group?.parent?.[0]?.title ||
        foodDetails?.item?.parent?.[0]?.title;
    const formattedPrice = foodDetails?.item?.parent?.[0].price;
    const [title, setTitle] = React.useState(calculatedTitle);
    const [price, setPrice] = React.useState(formattedPrice);
    const isUserEditingPrice = React.useRef(false);

    React.useEffect(() => {
        setTitle(calculatedTitle);
        !isUserEditingPrice.current && setPrice(formatNumber(formattedPrice, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator));
    }, [calculatedTitle, formattedPrice]);

    const handleOpen = (e) => {
        e.stopPropagation();
        setOpen(true);
    };

    const itemNumber = foodDetails?.group?.parent?.[0].itemNumber ? foodDetails?.group?.parent?.[0].itemNumber : foodDetails?.item?.parent?.[0].itemNumber;

    const [image, setImage] = React.useState("");

    React.useEffect(() => {
        if (listType === "group") {
            let temp = list;
            if (updatedImage && updatedImage.length > 0) {
                temp[parentIndex][i].group.parent[0].image = updatedImage[0].key;
                try {
                    setImage(updatedImage[0].value);
                }
                catch (e) {
                    if (updatedImage[0].key) {
                        API_CALLS.getFoodImageApiCall(
                            headersConfigData,
                            siteId.get(),
                            updatedImage[0].key
                        )
                            .then(async (response) => {
                                const blob = await response.blob();  // Handle image as a blob
                                const image = URL.createObjectURL(blob);
                                setImage(image)
                            }
                            );
                    }
                    else
                        setImage(DummyFoodImage);
                }
                setList(temp);
            }
        }

        if (listType === "item") {
            let temp = list;
            if (updatedImage && updatedImage.length > 0) {
                temp[parentIndex][i].item.parent[0].image = updatedImage[0].key;
                try {
                    setImage(updatedImage[0].value);
                }
                catch (e) {
                    if (updatedImage[0].key) {
                        API_CALLS.getFoodImageApiCall(
                            headersConfigData,
                            siteId.get(),
                            updatedImage[0].key
                        )
                            .then(async (response) => {
                                const blob = await response.blob();  // Handle image as a blob
                                const image = URL.createObjectURL(blob);
                                setImage(image)
                            }
                            );
                    }
                    else
                        setImage(DummyFoodImage);
                }
                setList(temp);
            }
        }
    }, [updatedImage]);

    React.useEffect(() => {
        try {
            let temp =
                img !== "" ?
                    require("../../../assets/images/FoodImages/" + img)
                    : DummyFoodImage;
            setImage(temp);
        }
        catch (e) {
            if (img) {
                API_CALLS.getFoodImageApiCall(
                    headersConfigData,
                    siteId.get(),
                    img
                )
                    .then(async (response) => {
                        const blob = await response.blob();  // Handle image as a blob
                        const image = URL.createObjectURL(blob);
                        setImage(image)
                    }
                    );
            }
            else
                setImage(DummyFoodImage);
        }
    }, [list]);

    const onChangeTitle = (e) => {
        handleOnChangeTitle(e, listType, "parent", parentIndex, i, itemNumber, 0, 0);
        setTitle(e.target.value);
    }

    const onChangePrice = (e) => {
        isUserEditingPrice.current = true;
        handleOnChangePrice(e, listType, "parent", parentIndex, i, 0, 0);
        setPrice(e.target.value);
    }

    return (
        <ItemRow className="add-item-header">
            <div className="input-section">
                <div className="arrow-container">
                    <Tooltip title={t("Move_up")}>
                        <button>
                            <ArrowUpwardIcon
                                onClick={(e) =>
                                    changeOrder(i, parentIndex, "UP", e, 0, itemNumber)
                                }
                            />
                        </button>
                    </Tooltip>
                    <Tooltip title={t("Move_down")}>
                        <button>
                            <ArrowDownwardIcon
                                onClick={(e) =>
                                    changeOrder(i, parentIndex, "DOWN", e, 0, itemNumber)
                                }
                            />
                        </button>
                    </Tooltip>
                </div>
                <div className="food-img-wrapper" onClick={(e) => handleOpen(e)}>
                    <img src={image} alt="food-img" />
                </div>
                <input
                    maxLength={30}
                    onChange={(e) => onChangeTitle(e)}
                    onClick={(e) => e.stopPropagation()}
                    value={title}
                />
            </div>
            {listType === "item" && (
                <div className="price-input">
                    <span>{siteSettingsData.CurrencySymbol}</span>
                    <input
                        maxLength={30}
                        name="price"
                        onBlur={(e) =>{isUserEditingPrice.current = false; setPrice(formatNumber(e.target.value, siteSettingsData.CurrencyThousandsSeparator, siteSettingsData.CurrencyDecimalSeparator))}}
                        onChange={(e) => onChangePrice(e)}
                        placeholder={`0${siteSettingsData.CurrencyDecimalSeparator}00`}
                        value={price}
                    />
                </div>
            )}
            <div className="action-wrapper">
                <Tooltip title={t("Add_item")}>
                    <button
                        className="add-btn"
                        onClick={(e) => {
                            handleOnAddButton(i, listType, parentIndex, e);
                        }}
                    >
                        <AddIcon />
                    </button>
                </Tooltip>
                <Tooltip title={t("Delete_item")}>
                    <IconButton
                        disabled={
                            isUserBasic(getUserRole && getUserRole?.Role) ||
                            isUserReadOnly(getUserRole && getUserRole?.Role)
                        }
                        aria-label="delete"
                        onClick={(e) => handleOnDelete(i, null, listType, "parent", title, parentIndex, itemNumber, e)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </div>
            {open && <FoodImagePopup
                open={open}
                setImage={setUpdatedImage}
                setOpen={setOpen}
                title={title}
                setIsSaveMenuDisabled={setIsSaveMenuDisabled}
            />}
        </ItemRow>
    );
};

export default AddGroup;
